import { AppService } from '@ajin/services/app.service';
import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { AuthGuard } from '@projects/core/auth/guards/auth.guard';
import { NoAuthGuard } from '@projects/core/auth/guards/noAuth.guard';
import { LayoutComponent } from '@projects/core/layout/layout.component';
import { ajinConfig } from './ajin.config';
import { initialDataResolver } from './app.resolvers';

export const appRoutes: Route[] = [
	{ path: '', pathMatch: 'full', redirectTo: 'dashboard' },
	{ path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },
	{
		path: '',
		canActivate: [NoAuthGuard],
		component: LayoutComponent,
		resolve: {
			config: () => inject(AppService).setConfig(ajinConfig)
		},
		data: {
			layout: 'empty'
		},
		children: [
			{ path: 'forgot-password', loadComponent: () => import('@core/modules/auths/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) },
			{ path: 'reset-password', loadComponent: () => import('@core/modules/auths/reset-password/reset-password.component').then(m => m.ResetPasswordComponent) },
			{ path: 'reset-current-password', loadComponent: () => import('@core/modules/auths/reset-current-password/reset-current-password.component').then(m => m.ResetCurrentPasswordComponent) },
			{ path: 'sign-in', loadComponent: () => import('@core/modules/auths/sign-in/sign-in.component').then(m => m.SignInComponent) },
			{ path: 'sign-out', loadComponent: () => import('@core/modules/auths/sign-out/sign-out.component').then(m => m.SignOutComponent) },
		]
	},
	{
		path: '',
		canActivate: [AuthGuard],
		component: LayoutComponent,
		resolve: {
			config: () => inject(AppService).setConfig(ajinConfig),
			initialData: initialDataResolver
		},
		children: [
			{ path: 'reset-current-password', loadComponent: () => import('@core/modules/auths/reset-current-password/reset-current-password.component').then(m => m.ResetCurrentPasswordComponent) },
			{ path: 'dashboard', loadChildren: () => import('@projects/worker/app/modules/dashboard-v3/dashboard-v3.routes') },

		]
	},
	{ path: '**', redirectTo: 'dashboard' }
];
